import {GridColDef} from '@mui/x-data-grid';

export interface NestedSearchGridRow {
  searchID: number;
  id: string;
  name: string;
  lastCompleteTime: string;
  searchGroup: string;
}

export const nestedColumns: GridColDef[] = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 0.6,
    minWidth: 72,
  },
  {
    field: 'name',
    headerName: 'Search Name',
    flex: 2,
    minWidth: 120,
  },
  {
    field: 'lastCompleteTime',
    headerName: 'Last Complete Time',
    flex: 1.5,
    minWidth: 120,
  },
  {
    field: 'searchGroup',
    headerName: 'Search Group',
    flex: 1.5,
    minWidth: 100,
  },
];
